export const INLINE_TEXT_WIDTH = 160;
export const INLINE_TEXT_HEIGHT = 30;
